import service from '../service.js'

export default {
  /**
   * 添加或修改二维码
   * @returns 
   */
  Save: (params) => {
    return service({
      url: '/QrCode/Save',
      method: 'post',
      data: params
    })
  },
  /**
   * 二维码信息列表
   * @param {*} isDescending 
   * @param {*} pageIndex 
   * @param {*} pageSize 
   * @param {*} state 
   * @param {*} search 
   * @returns 
   */
  GetList: (isDescending, pageIndex, pageSize, state, search) => {
    return service({
      url: '/QrCode/GetList',
      method: 'get',
      params: { isDescending, pageIndex, pageSize, state, search }
    })
  },
  /**
   * 获取单个二维码信息
   * @param {*} id 
   * @returns 
   */
  Get: (id) => {
    return service({
      url: '/QrCode/Get',
      method: 'get',
      params: { id }
    })
  },
  /**
   * 获取二维码下拉控件
   * @returns 
   */
  GetDropDownList: () => {
    return service({
      url: '/QrCode/GetDropDownList',
      method: 'get',
    })
  },
}